module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid65_960x876.e437100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid65_960x876.jpg
// module id = CYtp
// module chunks = 0